import { onAbort, withTimeout } from './fetchTimeout';

export type WebfingerResponse = {
  subject: string;
  links: {
    rel: string;
    href: string;
    properties: Record<string, string>;
  }[];
};

type IdpInfo = {
  idpId: string;
  multipleLinks: boolean;
};

export const getIdpFromWebfinger: (
  baseUrl: string,
) => (username?: string) => Promise<IdpInfo | undefined> =
  (baseUrl) => async (username) => {
    const fetcher = withTimeout(5000, fetch);
    const webfingerResponse = fetcher(
      `${baseUrl}/api/v1/.well-known/webfinger?resource=acct:${username}`,
      {
        headers: new Headers({
          Accept: 'application/jrd+json',
        }),
      },
    );
    // return undefined on timeout because we want to simply "fall back" to
    // password auth, basically just assuming the user doesn't have an external IDP.
    const response = await onAbort(() => undefined, webfingerResponse);
    const json = await response?.json();
    return extractIdpInfo(json);
  };

export function extractIdpInfo(
  webfingerResp?: WebfingerResponse,
): IdpInfo | undefined {
  const idpId = webfingerResp?.links[0]?.properties?.['okta:idp:id'];
  if (webfingerResp?.links.length > 1 && idpId) {
    return {
      idpId,
      multipleLinks: true,
    };
  }
  if (idpId) {
    return {
      idpId,
      multipleLinks: false,
    };
  }
  return undefined;
}
